module.exports = __webpack_public_path__ + "media/mobile-landing-video.eb08da42.mp4";